import React from 'react'
import RNMaskedInput from 'react-text-mask'

import TextInput, { TextInputProps } from './text-input'

/* -----------------------------------------------------------------------------
 * MaskedInput
 *
 * react-text-mask around the kit's TextInput. The value passed to
 * onChangeText is the one after the mask ran.
 * -------------------------------------------------------------------------- */

export type MaskedInputProps = TextInputProps & {
  nativeMask?: string
  webMask: Array<RegExp | string>
}

const MaskedInput = React.forwardRef<HTMLInputElement, MaskedInputProps>(
  ({ nativeMask, webMask, onChange, onChangeText, ...props }, ref) => {
    const patchedOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange && onChange(event)
      onChangeText && onChangeText(event.target.value)
    }

    return (
      <RNMaskedInput
        ref={ref as any}
        guide={false}
        mask={webMask}
        onChange={patchedOnChange}
        {...(props as any)}
        render={(maskRef, maskProps) => (
          <TextInput ref={maskRef as any} {...maskProps} />
        )}
      />
    )
  }
)

export default MaskedInput
